import * as yup from "yup";
import {
  DayOfWeek,
  OffsetUnit,
  SpecificTimezone,
  TimeOfDay,
  TimezoneType,
} from "models/automation";
import { DependencyTriggerType, OnboardingReferenceEvent, TimingTriggerType, TriggerType } from "features/Trigger/TemplateTrigger/models";

const timingData = yup.object({ // eslint-disable-line @typescript-eslint/no-unused-vars
  referenceEvent: yup.mixed<OnboardingReferenceEvent>().required().label("Event"),
  offset: yup.number().required().integer().label("Offset"),
  offsetUnit: yup
    .mixed<OffsetUnit>()
    .label("Day/Week/Month")
    .when("offset", {
      is: (value: number) => value !== 0,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable()
        .test(
          "must-be-null",
          "Unit must not be set when offset is 0",
          (value) => value == null,
        ),
    }),
  dayOfWeek: yup
    .mixed<DayOfWeek>()
    .label("Day Of Week")
    .when("offsetUnit", {
      is: (value: string) => value === "specific_day",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }),
  timeOfDay: yup.mixed<TimeOfDay>().label("Send At").notRequired(),
  timezoneType: yup.mixed<TimezoneType>().label("Timezone Source").notRequired(),
  specificTimezone: yup
    .mixed<SpecificTimezone>()
    .label("Which Timezone?")
    .when("targetTimezone", {
      is: (value: string) => value === "specificTimezone",
      then: (schema) => schema.required().default("America/Los_Angeles"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export type TimingDataSchema = yup.InferType<typeof timingData>;

export const timingSchema = yup.object({
  type: yup.mixed<Extract<TriggerType, TimingTriggerType>>().required().nonNullable(),
  data: yup.mixed<TimingDataSchema>().required().nonNullable(),
});

export type TimingSchema = yup.InferType<typeof timingSchema>;

const dependencyData = yup.object({ // eslint-disable-line @typescript-eslint/no-unused-vars
  event: yup.mixed<"task.completed">().required(),
  dependencyType: yup.mixed<"TaskTemplate">().required(),
  dependencyId: yup.string().label("Task").required(),
});

type DependencyDataSchema = yup.InferType<typeof dependencyData>;

const dependencySchema = yup.object({ // eslint-disable-line @typescript-eslint/no-unused-vars
  type: yup.mixed<Extract<TriggerType, DependencyTriggerType>>().required().nonNullable(),
  data: yup.mixed<DependencyDataSchema>().required().nonNullable(),
});

type DependencySchema = yup.InferType<typeof dependencySchema>;

export const trigger = yup.mixed<TimingSchema | DependencySchema>().defined().nonNullable();

export type TriggerSchema = yup.InferType<typeof trigger>;
